import { Button } from '@eliadmin/core/src/components/ui/button';
import {
  ResponsiveDialog,
  ResponsiveDialogClose,
  ResponsiveDialogContent,
  ResponsiveDialogTrigger,
  ResponsiveDialogTitle,
} from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useState } from 'react';
import { MdOutlineSort } from 'react-icons/md';
import { coursesortOptions } from '../jobportal-courses-header';
import { useJobportalCoursesStore } from '@eliadmin/core/src/stores/jobportal-courses-store';

export const CoursesSortButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslations();
  const { setFilter, applyFilter, filter } = useJobportalCoursesStore();

  const handleFilterChange = (filter: {
    order: 'asc' | 'desc';
    orderBy: 'created_at' | 'salary' | 'distance';
  }) => {
    setFilter(filter);
    applyFilter(filter);
  };
  return (
    <ResponsiveDialog open={isOpen} onOpenChange={setIsOpen}>
      <ResponsiveDialogTrigger asChild>
        <Button className="w-full gap-4">
          <MdOutlineSort className="h-5 w-5" />
          {t('text2302')}
        </Button>
      </ResponsiveDialogTrigger>
      <ResponsiveDialogContent className="flex flex-col items-center justify-center gap-2 py-4 pb-10">
        <ResponsiveDialogTitle className="sr-only">{t('text2302')}</ResponsiveDialogTitle>
        {coursesortOptions.map((option, index) => (
          <ResponsiveDialogClose key={index} asChild>
            <button
              type="button"
              className={cn(
                'cursor-pointer text-center text-base font-normal text-primary',
                filter.order === option.value.split(':')[1] &&
                  filter.orderBy === option.value.split(':')[0]
                  ? 'font-semibold'
                  : '',
              )}
              onClick={() =>
                handleFilterChange({
                  order: option.value.split(':')[1] as 'asc' | 'desc',
                  orderBy: option.value.split(':')[0] as 'created_at' | 'salary' | 'distance',
                })
              }
            >
              {option.label}
            </button>
          </ResponsiveDialogClose>
        ))}
      </ResponsiveDialogContent>
    </ResponsiveDialog>
  );
};
